










































import HeaderPage from '../HeaderPage/HeaderPage.vue';

export default {
  name: 'About',
  data() {
    return {
      title: 'About Me',
    };
  },
  components: {
    HeaderPage,
  },
};
